import { FC, useEffect } from 'react';
import styled from 'styled-components';

import MobileMenuChildMenu from 'components/Header/Mobile/ChildMenu';
import MobileMenuParentMenu from 'components/Header/Mobile/ParentMenu';

type MobileMenuProps = {
  elementMenu?: any[];
  isMobileNavOpen?: boolean;
  mobileHeaderHeight?: string;
  openMenu?: number;
  setOpenMenu?: () => void;
  setOpenMenuGroup?: () => void;
  openMenuGroup?: string;
  setParentOpen: () => void;
  parentOpen?: boolean;
  setIsMobileNavOpen?: () => void;
};

const MobileMenu: FC<MobileMenuProps> = ({
  elementMenu,
  isMobileNavOpen,
  mobileHeaderHeight,
  openMenu,
  setIsMobileNavOpen,
  setOpenMenu,
  setOpenMenuGroup,
  openMenuGroup,
  setParentOpen,
  parentOpen,
}) => {
  useEffect(() => {
    if (isMobileNavOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = null;
    }
  }, [isMobileNavOpen]);

  return (
    <Container isMobileNavOpen={isMobileNavOpen}>
      <MobileMenuParentMenu
        elementMenu={elementMenu}
        isMobileNavOpen={isMobileNavOpen}
        mobileHeaderHeight={mobileHeaderHeight}
        openMenu={openMenu}
        setOpenMenu={setOpenMenu}
        setOpenMenuGroup={setOpenMenuGroup}
        setParentOpen={setParentOpen}
      />
      <MobileMenuChildMenu
        elementMenu={elementMenu}
        isMobileNavOpen={isMobileNavOpen}
        mobileHeaderHeight={mobileHeaderHeight}
        openMenu={openMenu}
        openMenuGroup={openMenuGroup}
        setIsMobileNavOpen={setIsMobileNavOpen}
        setOpenMenu={setOpenMenu}
        parentOpen={parentOpen}
      />
    </Container>
  );
};

export default MobileMenu;

const Container = styled.div`
  position: absolute;
  width: 100vw;
  height: ${({ isMobileNavOpen }) => (isMobileNavOpen ? 'calc(100vh + 1px)' : '0')};
  top: 0;
  left: 0;
  z-index: -1;
  background: ${({ isMobileNavOpen }) => (isMobileNavOpen ? 'white' : 'transparent')};
  transition: background 0.3s ease-in-out;
  overflow-y: scroll;
  overflow-x: hidden;

  .mobile-child-menu {
    transform: translateX(-100vw);
    height: 100dvh;
  }

  .mobile-parent-menu.open {
    animation: moveRightOutIn 0.3s forwards;
    background: white;
  }
  .mobile-child-menu.closed {
    animation: moveRightInOut 0.3s forwards;
  }
  .mobile-parent-menu.closed {
    animation: moveLeftOut 0.3s forwards;
  }
  .mobile-child-menu.open {
    animation: moveLeftIn 0.3s forwards;
    background: white;
  }

  @keyframes moveLeftOut {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-100vw);
    }
  }

  @keyframes moveLeftIn {
    0% {
      transform: translateX(100vw);
    }
    100% {
      transform: translateX(0);
    }
  }

  @keyframes moveRightInOut {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(100vw);
    }
  }

  @keyframes moveRightOutIn {
    0% {
      transform: translateX(-100vw);
    }
    100% {
      transform: translateX(0);
    }
  }

  @media (min-width: 992px) {
    display: none;
  }
`;
